import { Laufzeit } from './types';

export const euro = (wert: number | null | undefined) =>
  (Number(wert) || 0).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';

export const datum = (wert: string | null | undefined) => {
  if (!wert) return '—';
  const parsed = new Date(wert);
  return Number.isNaN(parsed.getTime()) ? wert : parsed.toLocaleDateString('de-DE');
};

export const afaEndeText = (laufzeit: Laufzeit | null) => {
  if (!laufzeit) return '—';
  const monate = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
  ];
  return `${monate[laufzeit.ende_monat - 1]} ${laufzeit.ende_jahr}`;
};

export const restlaufzeitText = (laufzeit: Laufzeit | null) => {
  if (!laufzeit) return '—';
  if (laufzeit.abgegangen) return 'Abgegangen';
  if (laufzeit.abgeschlossen) return 'Vollständig abgeschrieben';
  const jahre = Math.floor(laufzeit.restmonate / 12);
  const monate = laufzeit.restmonate % 12;
  return [
    jahre ? `${jahre} ${jahre === 1 ? 'Jahr' : 'Jahre'}` : '',
    monate ? `${monate} ${monate === 1 ? 'Monat' : 'Monate'}` : ''
  ].filter(Boolean).join(' ');
};

/** Entfernt Bank-Metadaten, die niemals ein sinnvoller Inventarname sind. */
export const saubereBezeichnung = (verwendungszweck?: string | null, partner?: string | null) => {
  const bereinigen = (wert: string) => wert
    .replace(/\bIBAN\s*:?\s*[A-Z]{2}[A-Z0-9 ]{12,34}/gi, '')
    .replace(/\bBIC\s*:?\s*[A-Z0-9]{8,11}/gi, '')
    .replace(/\bSecureGo\s*plus\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/[\s,;:-]+$/g, '')
    .trim();
  const zweck = bereinigen(verwendungszweck || '');
  if (zweck && zweck.length >= 5 && !/^rechnung\s*(nr|nummer)?/i.test(zweck)) return zweck.slice(0, 100);
  return bereinigen(partner || '').slice(0, 100);
};

export const confidenceLabel = (wert: number) => {
  if (wert >= 80) return 'hohe Sicherheit';
  if (wert >= 55) return 'mittlere Sicherheit';
  return 'unsicher – Beleg selbst prüfen';
};
